export enum EPublicRoutes {
  INDEX = '/',
  STATIONS = '/stations',
  STATION = '/station/:stationId',
  STATION_CHARGERS = '/station/:stationId/chargers',
  SCAN = '/scan',
}

export const PUBLIC_ROUTES = Object.values(EPublicRoutes)

export enum EProtectedRoutes {
  CHARGING_POINT = '/station/:stationId/charging-point/:chargingPointId',
  WALLET = '/wallet',
  CARD_ADD = '/card/add',
  PROFILE = '/profile',
}

export const PROTECTED_ROUTES = Object.values(EProtectedRoutes)

export enum EAuthRoutes {
  AUTH = 'auth',
  LOGIN = 'login',
  REGISTER = 'register',
  FORGOT_PASSWORD = 'forgot-password',
  NEW_PASSWORD = 'new-password',
}

export const AUTH_ROUTES = Object.values(EAuthRoutes)

export const AppRoutes = {
  ...EPublicRoutes,
  ...EProtectedRoutes,
  ...EAuthRoutes,
}
